import React, { useState } from 'react';
import axios from 'axios';

const BulkUpload = ({ onClose, onSuccess }) => {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [result, setResult] = useState(null);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setResult(null);
  };

  const handleUpload = async () => {
    if (!file) return;

    setUploading(true);
    const reader = new FileReader();
    
    reader.onload = async (e) => {
      try {
        const questions = JSON.parse(e.target.result);
        
        if (!Array.isArray(questions)) {
          throw new Error('JSON must be an array of questions');
        }
        
        // Validate each question has required fields
        for (let i = 0; i < questions.length; i++) {
          const q = questions[i];
          const required = ['question', 'options', 'correctAnswer', 'subject', 'class', 'difficulty'];
          const missing = required.filter(field => !q[field]);
          
          if (missing.length > 0) {
            throw new Error(`Question ${i + 1} missing required fields: ${missing.join(', ')}`);
          }
          
          if (!Array.isArray(q.options) || q.options.length !== 4) {
            throw new Error(`Question ${i + 1} must have exactly 4 options`);
          }
          
          if (!q.options.includes(q.correctAnswer)) {
            throw new Error(`Question ${i + 1} correctAnswer must match one of the options`);
          }
        }

        let success = 0;
        let errors = [];

        console.log('Processing', questions.length, 'questions');
        
        for (let i = 0; i < questions.length; i++) {
          try {
            console.log('Uploading question', i + 1, ':', questions[i].question);
            const response = await axios.post('/api/quiz/questions', {
              ...questions[i],
              createdBy: 'Bulk Upload'
            });
            console.log('Question', i + 1, 'uploaded successfully');
            success++;
          } catch (error) {
            console.error('Error uploading question', i + 1, ':', error);
            errors.push(`Question ${i + 1}: ${error.response?.data?.error || error.message}`);
          }
        }

        setResult({ success, errors, total: questions.length });
        if (success > 0) {
          console.log('Upload completed successfully, refreshing question list');
          onSuccess();
        }
      } catch (error) {
        setResult({ success: 0, errors: [error.message], total: 0 });
      }
      setUploading(false);
    };

    reader.readAsText(file);
  };

  const sampleFormat = [
    {
      question: "What is 2 + 2?",
      options: ["3", "4", "5", "6"],
      correctAnswer: "4",
      subject: "Math",
      chapter: "Chapter 1",
      class: "1",
      difficulty: "easy",
      hint: "Count on your fingers"
    }
  ];

  return (
    <div className="modal-overlay">
      <div className="question-form" style={{ maxWidth: '600px' }}>
        <h3>Bulk Upload Questions</h3>
        
        <div style={{ marginBottom: '20px' }}>
          <label>Select JSON File:</label>
          <input
            type="file"
            accept=".json"
            onChange={handleFileChange}
            style={{ width: '100%', padding: '10px', marginTop: '5px' }}
          />
        </div>

        {result && (
          <div style={{ 
            padding: '15px', 
            borderRadius: '5px', 
            marginBottom: '20px',
            background: result.success > 0 ? '#d4edda' : '#f8d7da',
            color: result.success > 0 ? '#155724' : '#721c24'
          }}>
            <h4>Upload Result:</h4>
            <p>✅ Successfully added: {result.success}/{result.total} questions</p>
            {result.errors.length > 0 && (
              <div>
                <p>❌ Errors:</p>
                <ul style={{ maxHeight: '100px', overflow: 'auto' }}>
                  {result.errors.slice(0, 5).map((error, i) => (
                    <li key={i}>{error}</li>
                  ))}
                  {result.errors.length > 5 && <li>... and {result.errors.length - 5} more</li>}
                </ul>
              </div>
            )}
          </div>
        )}

        <div style={{ marginBottom: '20px' }}>
          <h4>JSON Format Example:</h4>
          <pre style={{ 
            background: '#f8f9fa', 
            padding: '10px', 
            borderRadius: '5px', 
            fontSize: '12px',
            overflow: 'auto',
            maxHeight: '200px'
          }}>
            {JSON.stringify(sampleFormat, null, 2)}
          </pre>
        </div>

        <div className="form-actions">
          <button 
            onClick={handleUpload} 
            disabled={!file || uploading}
            style={{ 
              background: uploading ? '#ccc' : 'linear-gradient(45deg, #00FF00, #32CD32)',
              color: 'white'
            }}
          >
            {uploading ? 'Uploading...' : 'Upload Questions'}
          </button>
          <button onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default BulkUpload;